/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';

const Specifications = React.lazy(() => import('./index'));

export const SpecificationsSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  return (
    <Suspense fallback={<div />}>
      <Specifications {...props} />
    </Suspense>
  );
};
